<template>
  <b-modal :id="id" :title="'Цель ' + target.target" header-bg-variant="dark" header-text-variant="light" size="lg" hide-footer @hidden="close()">
    <!-- UI-12: Subnet expansion section -->
    <div v-if="target.type === 'Network' || target.type === 'IP range'" class="mb-3">
      <b-card bg-variant="light">
        <b-row align-v="center">
          <b-col>
            <b-badge :variant="target.type === 'Network' ? 'danger' : 'warning'" class="mr-2">{{ target.type }}</b-badge>
            <span style="color: var(--text-foreground);">{{ target.target }}</span>
          </b-col>
          <b-col cols="auto">
            <b-button variant="outline-primary" size="sm" @click="expandTarget" :disabled="expanding">
              <b-spinner v-if="expanding" small class="mr-1"/>
              {{ expanding ? 'Раскрытие...' : 'Раскрыть подсеть' }}
            </b-button>
          </b-col>
        </b-row>
        <div v-if="expandedHosts !== null" class="mt-2">
          <b-form-text class="mb-2">Найдено хостов: {{ expandedCount }}</b-form-text>
          <b-list-group flush style="max-height: 200px; overflow-y: auto;">
            <b-list-group-item v-for="(ip, i) in expandedHosts" :key="i" class="py-1">
              <code>{{ ip }}</code>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-card>
    </div>
    <b-tabs fill card active-nav-item-class="text-danger">
      <b-tab lazy title-link-class="text-secondary">
        <template #title>
          <b-icon icon="stack"/> Порты
        </template>
        <target-port :targetId="target.id"/>
      </b-tab>
      <b-tab lazy title-link-class="text-secondary">
        <template #title>
          <b-icon icon="cpu-fill"/> Технологии
        </template>
        <technology :targetId="target.id"/>
      </b-tab>
      <b-tab lazy title-link-class="text-secondary">
        <template #title>
          <b-icon icon="bug-fill"/> Уязвимости
        </template>
        <vulnerability :targetId="target.id"/>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi';
import TargetPort from '@/modals/targets/TargetPort';
import Technology from '@/modals/targets/Technology';
import Vulnerability from '@/modals/targets/Vulnerability';
export default {
  name: 'targetDetailsModal',
  mixins: [RekonoApi],
  props: {
    id: String,
    target: Object
  },
  components: {
    TargetPort,
    Technology,
    Vulnerability,
  },
  data () {
    return {
      expanding: false,
      expandedHosts: null,
      expandedCount: 0
    }
  },
  methods: {
    expandTarget () {
      this.expanding = true
      this.expandedHosts = null
      this.get(`/api/targets/${this.target.id}/expand/`)
        .then(response => {
          this.expandedHosts = response.data.hosts
          this.expandedCount = response.data.count
        })
        .catch(() => {
          this.danger('Ошибка', 'Не удалось раскрыть подсеть')
        })
        .finally(() => { this.expanding = false })
    },
    close () {
      this.expandedHosts = null
      this.expandedCount = 0
      this.$emit('close')
    }
  }
}
</script>